var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18471)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18471)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFEEB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.16665,
    y: 12.5667,
    width: 7.6,
    height: 1.93333,
    rx: 0.966667,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10487_18471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.93375,
    y: 20.1908,
    width: 14.4667,
    height: 15.3333,
    rx: 7.23333,
    transform: "rotate(-16 2.93375 20.1908)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.83328,
    y: 16.2333,
    width: 4.06667,
    height: 1.93333,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.93323,
    y: 16.1333,
    width: 3.86667,
    height: 2.66667,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.89993,
    y: 7.49996,
    width: 6.13333,
    height: 9.66667,
    rx: 3.06667,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.6H9.53341L9 11.8668V10.6Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9333 10.6H14.3999L14.9333 11.8668V10.6Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_10487_18471",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5243 18.7332C15.3932 19.7709 13.8505 20.5898 11.9666 20.5898C10.0937 20.5898 8.55797 19.7803 8.4114 18.7512C5.9027 19.4697 4.06665 21.7805 4.06665 24.52V29.0533H19.9333V24.52C19.9333 21.7571 18.0658 19.4304 15.5243 18.7332Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5243 18.7332C15.3932 19.7709 13.8505 20.5898 11.9666 20.5898C10.0937 20.5898 8.55797 19.7803 8.4114 18.7512C5.9027 19.4697 4.06665 21.7805 4.06665 24.52V29.0533H19.9333V24.52C19.9333 21.7571 18.0658 19.4304 15.5243 18.7332Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5243 18.7332L15.5772 18.5403L15.3547 18.4793L15.3258 18.7081L15.5243 18.7332ZM8.4114 18.7512L8.6094 18.723L8.57703 18.4958L8.35633 18.559L8.4114 18.7512ZM4.06665 29.0533H3.86665V29.2533H4.06665V29.0533ZM19.9333 29.0533V29.2533H20.1333V29.0533H19.9333ZM15.3258 18.7081C15.2721 19.1337 14.9205 19.5532 14.3098 19.8735C13.7055 20.1906 12.8817 20.3898 11.9666 20.3898V20.7898C12.9354 20.7898 13.8249 20.5796 14.4956 20.2277C15.16 19.8792 15.6454 19.3704 15.7227 18.7583L15.3258 18.7081ZM11.9666 20.3898C11.0569 20.3898 10.2373 20.1929 9.63392 19.879C9.02419 19.5619 8.66962 19.1459 8.6094 18.723L8.2134 18.7794C8.29975 19.3857 8.78633 19.889 9.44934 20.2339C10.1187 20.582 11.0034 20.7898 11.9666 20.7898V20.3898ZM4.26665 24.52C4.26665 21.8721 6.04127 19.6381 8.46647 18.9435L8.35633 18.559C5.76412 19.3014 3.86665 21.6889 3.86665 24.52H4.26665ZM4.26665 29.0533V24.52H3.86665V29.0533H4.26665ZM19.9333 28.8533H4.06665V29.2533H19.9333V28.8533ZM19.7333 24.52V29.0533H20.1333V24.52H19.7333ZM15.4714 18.9261C17.9283 19.6 19.7333 21.8495 19.7333 24.52H20.1333C20.1333 21.6647 18.2034 19.2607 15.5772 18.5403L15.4714 18.9261Z",
    fill: "#111111",
    mask: "url(#path-12-inside-1_10487_18471)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7807 8.57778L14.7847 8.58585L14.7901 8.59306C14.9648 8.82568 15.0758 8.98634 15.1561 9.15617C15.2357 9.32467 15.2871 9.50687 15.3349 9.78367L15.3346 9.78372L15.3364 9.79091C15.4329 10.1768 15.4335 10.677 15.4335 10.9667C15.4335 11.1907 15.3715 13.3114 15.3451 14.2052C15.337 14.4808 15.4595 14.7428 15.6749 14.9139H15.0423L15.0478 12.1298V12.1296V11.8992V11.7188L14.8948 11.8144C14.661 11.9606 14.4675 12.047 14.2521 12.0978C14.0353 12.1489 13.7915 12.1654 13.4541 12.1655C12.8913 12.139 12.3907 11.7842 12.0425 11.3129C11.7666 10.9396 11.3633 10.6149 10.8714 10.592L9.17148 10.513C9.07884 10.5087 9.0005 10.5809 8.99719 10.6736L8.96073 11.6931H8.96073L8.96071 11.694L8.87457 14.9527H8.39688C8.38773 14.9527 8.38237 14.9501 8.37879 14.9473C8.3746 14.9441 8.37072 14.9389 8.36851 14.9322C8.3663 14.9254 8.36636 14.9189 8.36783 14.9139C8.36908 14.9095 8.37185 14.9042 8.37923 14.8988C8.56361 14.7637 8.67002 14.5467 8.66403 14.3182L8.56684 10.6105C8.60545 9.66559 8.9755 8.79993 9.67232 8.16028L9.67233 8.16029L9.67289 8.15976C9.95522 7.89654 10.2753 7.68943 10.6144 7.53856L10.6574 7.52206C11.5244 7.18952 12.4812 7.17512 13.3578 7.48136C13.9006 7.70626 14.3889 8.08025 14.766 8.54851L14.7807 8.57778Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10487_18471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 21.3333,
    fill: "white",
    transform: "translate(4.66675 1.60001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric06);
export default __webpack_public_path__ + "static/media/Generic 06.ccaf291b1ac159c614ef2bcd616fd590.svg";
export { ForwardRef as ReactComponent };